export default "__VITE_ASSET__CoP1DwAT__"